/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo } from '../models/Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LotsImportService {

    /**
     * @param taskId 
     * @param tenantId 
     * @param userId 
     * @param taskInstruction 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppLotsImportBackgroundExportOpenLots(
taskId?: string,
tenantId?: string,
userId?: string,
taskInstruction?: string,
requestBody?: Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/lots-import/background-export-open-lots',
            query: {
                'taskId': taskId,
                'tenantId': tenantId,
                'userId': userId,
                'taskInstruction': taskInstruction,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taskId 
     * @param tenantId 
     * @param userId 
     * @param taskInstruction 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppLotsImportBackgroundExportCloseLots(
taskId?: string,
tenantId?: string,
userId?: string,
taskInstruction?: string,
requestBody?: Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/lots-import/background-export-close-lots',
            query: {
                'taskId': taskId,
                'tenantId': tenantId,
                'userId': userId,
                'taskInstruction': taskInstruction,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taskId 
     * @param tenantId 
     * @param userId 
     * @param sessionId 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppLotsImportBackgroundImportOpenLots(
taskId?: string,
tenantId?: string,
userId?: string,
sessionId?: string,
requestBody?: Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/lots-import/background-import-open-lots',
            query: {
                'taskId': taskId,
                'tenantId': tenantId,
                'userId': userId,
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taskId 
     * @param tenantId 
     * @param userId 
     * @param sessionId 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppLotsImportBackgroundImportCloseLots(
taskId?: string,
tenantId?: string,
userId?: string,
sessionId?: string,
requestBody?: Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/lots-import/background-import-close-lots',
            query: {
                'taskId': taskId,
                'tenantId': tenantId,
                'userId': userId,
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taskId 
     * @param fileName 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppLotsImportExportOpenLotsInternal(
taskId: string,
fileName?: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/lots-import/export-open-lots-internal/{taskId}',
            path: {
                'taskId': taskId,
            },
            query: {
                'fileName': fileName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taskId 
     * @param fileName 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppLotsImportExportCloseLotsInternal(
taskId: string,
fileName?: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/lots-import/export-close-lots-internal/{taskId}',
            path: {
                'taskId': taskId,
            },
            query: {
                'fileName': fileName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
